import React, { useEffect } from "react";
import { Switch, Route, Redirect, useHistory, useLocation } from "react-router-dom";
import routes, { RouteWithSubRoutes } from "./routes";
import { useUser } from "./hooks/useUser";
import { useAppUpdate } from "./hooks/useAppUpdate";

import { Content, Layout, Login } from "./pages";
import { CircularProgress } from "@mui/material";
import { Helmet } from "react-helmet";
import ResetPassword from "pages/ResetPassword/ResetPassword";
import Event from "pages/Event/Event";
import UpdateBanner from "lib/components/UpdateBanner";

// Component to save current URL before redirect to login
const SaveAndRedirect = () => {
  const location = useLocation();
  const currentPath = location.pathname + location.search;
  
  // Redirect to login with current path as query parameter
  if (currentPath !== "/login" && !currentPath.startsWith("/reset_password")) {
    return <Redirect to={`/login?redirect=${encodeURIComponent(currentPath)}`} />;
  }
  
  return <Redirect to="/login" />;
};

function App() {
  const { user, loadingUser } = useUser();
  const history = useHistory();

  // Hook pentru actualizări - rulează doar când utilizatorul este autentificat
  const { updateAvailable, updateApp, dismissUpdate, isUpdating } = useAppUpdate();

  // Check for login redirect after user logs in
  useEffect(() => {
    if (user.id) {
      const redirectUrl = localStorage.getItem("loginRedirect");
      if (redirectUrl) {
        localStorage.removeItem("loginRedirect");
        history.push(redirectUrl);
      }
    }
  }, [user.id, history]);

  return loadingUser ? (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <CircularProgress />
    </div>
  ) : (
    <React.Fragment>
      {/* Banner pentru actualizări */}
      <UpdateBanner
        open={updateAvailable}
        onUpdate={updateApp}
        onDismiss={dismissUpdate}
        isUpdating={isUpdating}
      />
      {user.id ? (
        <React.Fragment>
          <Helmet>
            <title>InBUSINESS CRM</title>
          </Helmet>

          <Layout />
          <Content>
            <Switch>
              {routes.map((route, i) => (
                <RouteWithSubRoutes key={i} {...route} />
              ))}
              <Route>
                <Redirect to="/" />
              </Route>
            </Switch>
          </Content>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Switch>
            <Route path="/login" render={(props) => <Login {...props} />} />
            <Route
              path="/reset_password/:token"
              render={(props) => <ResetPassword {...props} />}
            />
            <Route
              path="/events/:id"
              render={(props) => <Event {...props} />}
            ></Route>
            <Route>
              <SaveAndRedirect />
            </Route>
          </Switch>
        </React.Fragment>
      )}
    </React.Fragment>
  );
}

export default App;
